<template>
  <div class="crm-pieces">
    <h5 class="title text-uppercase" style="font-size: 12px;">Pièces collectées</h5>
    <p class="text-muted small mb-3">
      Pas de dépôt de fichier. Cochez si le téléconseiller a récupéré la pièce.
      Non collectée = rouge.
    </p>
    <div
      v-for="p in pieceKinds"
      :key="p.key"
      class="crm-piece-row mb-2"
      :class="pieces[p.key] ? 'ok' : 'ko'"
    >
      <span>{{ p.label }}</span>
      <label class="mb-0 d-flex align-items-center">
        <span class="small text-uppercase mr-2 font-weight-bold">
          {{ pieces[p.key] ? 'Collectée' : 'Non collectée' }}
        </span>
        <input
          type="checkbox"
          :checked="!!pieces[p.key]"
          :disabled="disabled"
          @change="$emit('toggle', p.key, $event.target.checked)"
        />
      </label>
    </div>
    <p class="text-muted small mb-0 mt-2">
      <template v-if="missing === 0">Toutes les pièces sont collectées.</template>
      <template v-else>{{ missing }} pièce{{ missing > 1 ? 's' : '' }} manquante{{ missing > 1 ? 's' : '' }}.</template>
    </p>
  </div>
</template>

<script>
import { PIECE_KINDS } from './crmStatuses'

export default {
  name: 'PiecesBlock',
  props: {
    crm: { type: Object, default: () => ({}) },
    disabled: { type: Boolean, default: false }
  },
  computed: {
    pieceKinds() {
      return PIECE_KINDS
    },
    pieces() {
      return {
        piece_carte_grise: !!(this.crm && this.crm.piece_carte_grise),
        piece_permis: !!(this.crm && this.crm.piece_permis),
        piece_releve: !!(this.crm && this.crm.piece_releve)
      }
    },
    missing() {
      return this.pieceKinds.filter((p) => !this.pieces[p.key]).length
    }
  }
}
</script>

<style scoped>
.crm-piece-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 44px;
  padding: 8px 12px;
  border-radius: 6px;
  border: 1px solid transparent;
  font-size: 14px;
  font-weight: 500;
}
.crm-piece-row.ok {
  border-color: rgba(40, 167, 69, 0.4);
  background: rgba(40, 167, 69, 0.12);
  color: #28a745;
}
.crm-piece-row.ko {
  border-color: rgba(220, 53, 69, 0.5);
  background: rgba(220, 53, 69, 0.12);
  color: #dc3545;
}
</style>
